var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRulesIconsRulesLearning = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.42 13.55",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.31.53h0c.58-.07,1.44,1,1.62,1.19a1,1,0,0,0,.41.13c.38,0,.59.16.59.54,0,1,0,7.06,0,8.5,0,.32-.19.64-.56.52a8.51,8.51,0,0,0-5,1.23,1.76,1.76,0,0,1-2.35,0c-.89-.79-4.42-1.42-5.19-1.23-.46.13-.42-.22-.43-.58V2.45c0-.34,0-.55.49-.6a.34.34,0,0,0,.23-.13c.3-.33.59-.7.87-1A.54.54,0,0,1,2.53.46,6.41,6.41,0,0,1,6.8,2a.82.82,0,0,0,.79,0A8.42,8.42,0,0,1,11.3.52ZM3,.49A1.19,1.19,0,0,0,1.88,1c-.23.3-.49.63-.65.82,3.85,1.09,4.66,2.58,6,2.57,1.54-.08,2.44-1.73,5.91-2.46C12.92,1.68,12.25,1,12,.65a.53.53,0,0,0-.42-.18,8.63,8.63,0,0,0-3.59,1.6,1.32,1.32,0,0,1-1.69,0A9.25,9.25,0,0,0,3,.5ZM8.14,8V5.12a.61.61,0,0,0-.61-.6H6.75c-.28,0-.57.21-.57.69v6.64c0,.38,0,.6,1,.59.76,0,1-.28,1-.64V8Z",
    fill: "#56a946",
    stroke: "#56a946",
    strokeMiterlimit: 10,
    strokeWidth: 0.92
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRulesIconsRulesLearning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RulesIcons_Rules_Learning.69ae967c.svg";
export { ForwardRef as ReactComponent };